import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseId() {
  try {
    return Number(localStorage.getItem("sabi_empresa_id")) || 1;
  } catch {
    return 1;
  }
}

const BASE_PATH = (licenseId) => `/admin/licenses/${licenseId}/hr/calendar/events`;

export const EventsApi = {
  /**
   * Listar eventos de una licencia
   * @param {Object} params - Filtros (branchId, from, to, includeInactive)
   */
  list: (params = {}) => {
    const licenseId = params.licenseId || getLicenseId();
    const queryParams = { ...params };
    delete queryParams.licenseId;
    return httpClient.get(`${BASE_PATH(licenseId)}${qs(queryParams)}`);
  },

  /**
   * Obtener un evento por ID
   */
  getOne: (id, licenseId = getLicenseId()) => {
    return httpClient.get(`${BASE_PATH(licenseId)}/${id}`);
  },

  /**
   * Crear un nuevo evento
   */
  create: (data, licenseId = getLicenseId()) => {
    return httpClient.post(`${BASE_PATH(licenseId)}`, data);
  },

  /**
   * Actualizar un evento existente
   */
  update: (id, data, licenseId = getLicenseId()) => {
    return httpClient.patch(`${BASE_PATH(licenseId)}/${id}`, data);
  },

  /**
   * Desactivar (eliminar) un evento
   */
  remove: (id, licenseId = getLicenseId()) => {
    return httpClient.delete(`${BASE_PATH(licenseId)}/${id}`);
  },
};

export default EventsApi;
